import { useEffect, useState, useRef } from 'react'
import Web3 from 'web3'
import { useWeb3React } from '@web3-react/core'
import { getWeb3NoAccount } from 'utils/web3'

/**
 * Provides a web3 instance using the provider provided by useWallet
 * with a fallback of an httpProver
 * Recreate web3 instance only if the provider change
 */
const useWeb3 = () => {
  const { provider } = useWeb3React()
  const refEth = useRef(provider)
  const [web3, setweb3] = useState(provider ? new Web3(provider.provider as any) : getWeb3NoAccount())

  useEffect(() => {
    if (provider !== refEth.current) {
      setweb3(provider ? new Web3(provider.provider as any) : getWeb3NoAccount())
      refEth.current = provider
    }
  }, [provider])

  return web3
}

export default useWeb3
